(() => {
  const sliders = document.querySelectorAll('[data-before-after]');
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    const range = slider.querySelector('[data-before-after-range]');
    const frame = slider.querySelector('.home-before-after__frame');
    if (!range || !frame) return;

    const update = () => {
      frame.style.setProperty('--before-after-position', `${range.value}%`);
    };

    update();
    range.addEventListener('input', update);
  });
})();
